import { RedAlertIcon } from '../assets/svgImages';

type AlertProps = {
  message: string;
  onOk: () => void;
  isOpen: boolean;
  onCancel: () => void;
};

export const AlertBoxModal = (props: AlertProps) => {
  if (!props.isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" />

      <div className="relative w-[90%] max-w-xl bg-red-50 border border-red-300 rounded-xl p-6 flex items-center justify-between shadow-xl">
        <div className="flex items-center gap-4">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
            <RedAlertIcon />
          </div>

          <div>
            <p className="font-semibold text-gray-900">Attention!</p>
            <p className="text-sm text-gray-700 mt-2">{props.message}</p>
          </div>
        </div>

        <div className="flex">
          <button
            onClick={props.onOk}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-medium me-4"
          >
            Ok
          </button>

          <button
            className="bg-primary-blue-500 hover:bg-primary-blue-600 text-white px-3 py-2 rounded-lg font-medium"
            onClick={props.onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertBoxModal;
